// Generated by PEG.js v0.11.0-master.b7b87ea, https://pegjs.org/

function pegSubclass(child, parent) {
	function C() {
		this.constructor = child;
	}
	C.prototype = parent.prototype;
	child.prototype = new C();
}

function pegSyntaxError(message, expected, found, location) {
	this.message = message;
	this.expected = expected;
	this.found = found;
	this.location = location;
	this.name = "SyntaxError";

	// istanbul ignore next
	if (typeof Error.captureStackTrace === "function") {
		Error.captureStackTrace(this, pegSyntaxError);
	}
}

pegSubclass(pegSyntaxError, Error);

pegSyntaxError.buildMessage = (expected, found, location) => {
	var DESCRIBE_EXPECTATION_FNS = {
		literal: (expectation) => '"' + literalEscape(expectation.text) + '"',

		class: (expectation) => {
			var escapedParts = expectation.parts.map((part) =>
				Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part),
			);

			return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
		},

		any: () => "any character",

		end: () => "end of input",

		other: (expectation) => expectation.description,

		not: (expectation) => "not " + describeExpectation(expectation.expected),
	};

	function hex(ch) {
		return ch.charCodeAt(0).toString(16).toUpperCase();
	}

	function literalEscape(s) {
		return s
			.replace(/\\/g, "\\\\")
			.replace(/"/g, '\\"')
			.replace(/\0/g, "\\0")
			.replace(/\t/g, "\\t")
			.replace(/\n/g, "\\n")
			.replace(/\r/g, "\\r")
			.replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch))
			.replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch));
	}

	function classEscape(s) {
		return s
			.replace(/\\/g, "\\\\")
			.replace(/\]/g, "\\]")
			.replace(/\^/g, "\\^")
			.replace(/-/g, "\\-")
			.replace(/\0/g, "\\0")
			.replace(/\t/g, "\\t")
			.replace(/\n/g, "\\n")
			.replace(/\r/g, "\\r")
			.replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch))
			.replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch));
	}

	function describeExpectation(expectation) {
		return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
	}

	function describeExpected(expected) {
		var descriptions = expected.map(describeExpectation);
		var i, j;

		descriptions.sort();

		if (descriptions.length > 0) {
			for (i = 1, j = 1; i < descriptions.length; i++) {
				if (descriptions[i - 1] !== descriptions[i]) {
					descriptions[j] = descriptions[i];
					j++;
				}
			}
			descriptions.length = j;
		}

		switch (descriptions.length) {
			case 1:
				return descriptions[0];

			case 2:
				return descriptions[0] + " or " + descriptions[1];

			default:
				return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
		}
	}

	function describeFound(found) {
		return found ? '"' + literalEscape(found) + '"' : "end of input";
	}

	return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function pegParse(input, options) {
	options = options !== undefined ? options : {};

	var pegFailed = {};

	var pegStartRuleFunctions = { Top: pegParseTop };
	var pegStartRuleFunction = pegParseTop;

	var pegC0 = "/";
	var pegC1 = ".";
	var pegC2 = "#";
	var pegC3 = "=";
	var pegC4 = "(";
	var pegC5 = ")";
	var pegC6 = ",";
	var pegC7 = "[";
	var pegC8 = "]";
	var pegC9 = "null";
	var pegC10 = "true";
	var pegC11 = "false";
	var pegC12 = "{";
	var pegC13 = "}";
	var pegC14 = ":";
	var pegC15 = "-";
	var pegC16 = '"';
	var pegC17 = "\\";

	var pegR0 = /^[$@]/;
	var pegR1 = /^[0-9]/;
	var pegR2 = /^[^\0-\x1F"\\]/;
	var pegR3 = /^[a-zA-Z0-9_-]/;
	var pegR4 = /^[ \n\t]/;

	var pegE0 = pegLiteralExpectation("/", false);
	var pegE1 = pegOtherExpectation("tag name");
	var pegE2 = pegOtherExpectation("class");
	var pegE3 = pegOtherExpectation("id");
	var pegE4 = pegLiteralExpectation("=", false);
	var pegE5 = pegLiteralExpectation("(", false);
	var pegE6 = pegLiteralExpectation(")", false);
	var pegE7 = pegLiteralExpectation(",", false);
	var pegE8 = pegOtherExpectation("variable");
	var pegE9 = pegOtherExpectation("null");
	var pegE10 = pegOtherExpectation("boolean");
	var pegE11 = pegLiteralExpectation("[", false);
	var pegE12 = pegLiteralExpectation("]", false);
	var pegE13 = pegLiteralExpectation("{", false);
	var pegE14 = pegLiteralExpectation("}", false);
	var pegE15 = pegLiteralExpectation(":", false);
	var pegE16 = pegOtherExpectation("number");
	var pegE17 = pegOtherExpectation("string");
	var pegE18 = pegOtherExpectation("identifier");
	var pegE19 = pegOtherExpectation("whitespace");

	var pegF0 = (variable) => ({ type: "variable", meta: { variable } });
	var pegF1 = (attributes) => ({ type: "annotation", meta: { attributes } });
	var pegF2 = (tag, value) => value;
	var pegF3 = (tag, primary, attributes, close) => {
		if (primary) {
			attributes = attributes || [];
			attributes.unshift({
				type: "attribute",
				name: "primary",
				value: primary,
			});
		}

		const [type, nesting] = close ? ["tag", 0] : ["tag_open", 1];
		return { type, nesting, meta: { tag, attributes } };
	};
	var pegF4 = (tag) => ({ type: "tag_close", nesting: -1, meta: { tag } });
	var pegF5 = (head, tail) => (!head ? [] : [head, ...tail]);
	var pegF6 = (item) => item;
	var pegF7 = (ids) => ids;
	var pegF8 = (classes) => classes;
	var pegF9 = (attribute) => attribute;
	var pegF10 = (name) => ({ type: "class", name, value: true });
	var pegF11 = (value) => ({ type: "attribute", name: "id", value });
	var pegF12 = (name, value) => ({ type: "attribute", name, value });
	var pegF13 = (name, head, tail) => (head ? [head, ...tail] : []);
	var pegF14 = (name, params) => {
		const parameters = {};
		for (const [index, { name, value }] of params.entries()) parameters[name || index] = value;
		return new Function(name, parameters);
	};
	var pegF15 = (name) => name;
	var pegF16 = (name, value) => ({ name, value });
	var pegF17 = (value) => value;
	var pegF18 = (prefix, head, tail) => {
		if (prefix === "@") return [head, ...tail];
		return new Variable([head, ...tail]);
	};
	var pegF19 = () => null;
	var pegF20 = () => true;
	var pegF21 = () => false;
	var pegF22 = (head, tail) => [head, ...tail];
	var pegF23 = (value) => value || [];
	var pegF24 = (head, tail) => Object.assign(head, ...tail);
	var pegF25 = (value) => value || {};
	var pegF26 = (key, value) => (key === "$$mdtype" ? {} : { [key]: value });
	var pegF27 = () => parseFloat(text());
	var pegF28 = (value) => value.join("");
	var pegF29 = (sequence) => sequence;

	var pegCurrPos = 0;
	var pegSavedPos = 0;
	var pegPosDetailsCache = [{ line: 1, column: 1 }];
	var pegExpected = [];
	var pegSilentFails = 0;

	var pegResult;

	if ("startRule" in options) {
		if (!(options.startRule in pegStartRuleFunctions)) {
			throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
		}

		pegStartRuleFunction = pegStartRuleFunctions[options.startRule];
	}

	function text() {
		return input.substring(pegSavedPos, pegCurrPos);
	}

	function offset() {
		return pegSavedPos;
	}

	function range() {
		return [pegSavedPos, pegCurrPos];
	}

	function location() {
		return pegComputeLocation(pegSavedPos, pegCurrPos);
	}

	function expected(description, location) {
		location = location !== undefined ? location : pegComputeLocation(pegSavedPos, pegCurrPos);

		throw pegBuildStructuredError(
			[pegOtherExpectation(description)],
			input.substring(pegSavedPos, pegCurrPos),
			location,
		);
	}

	function error(message, location) {
		location = location !== undefined ? location : pegComputeLocation(pegSavedPos, pegCurrPos);

		throw pegBuildSimpleError(message, location);
	}

	function pegLiteralExpectation(text, ignoreCase) {
		return { type: "literal", text: text, ignoreCase: ignoreCase };
	}

	function pegClassExpectation(parts, inverted, ignoreCase) {
		return {
			type: "class",
			parts: parts,
			inverted: inverted,
			ignoreCase: ignoreCase,
		};
	}

	function pegAnyExpectation() {
		return { type: "any" };
	}

	function pegEndExpectation() {
		return { type: "end" };
	}

	function pegOtherExpectation(description) {
		return { type: "other", description: description };
	}

	function pegComputePosDetails(pos) {
		var details = pegPosDetailsCache[pos];
		var p;

		if (details) {
			return details;
		}
		p = pos - 1;
		while (!pegPosDetailsCache[p]) {
			p--;
		}

		details = pegPosDetailsCache[p];
		details = {
			line: details.line,
			column: details.column,
		};

		while (p < pos) {
			if (input.charCodeAt(p) === 10) {
				details.line++;
				details.column = 1;
			} else {
				details.column++;
			}

			p++;
		}

		pegPosDetailsCache[pos] = details;

		return details;
	}

	var pegValidfilename = typeof options.filename === "string" && options.filename.length > 0;
	function pegComputeLocation(startPos, endPos) {
		var loc = {};

		if (pegValidfilename) loc.filename = options.filename;

		var startPosDetails = pegComputePosDetails(startPos);
		loc.start = {
			offset: startPos,
			line: startPosDetails.line,
			column: startPosDetails.column,
		};

		var endPosDetails = pegComputePosDetails(endPos);
		loc.end = {
			offset: endPos,
			line: endPosDetails.line,
			column: endPosDetails.column,
		};

		return loc;
	}

	function pegBegin() {
		pegExpected.push({ pos: pegCurrPos, variants: [] });
	}

	function pegExpect(expected) {
		var top = pegExpected[pegExpected.length - 1];

		if (pegCurrPos < top.pos) {
			return;
		}

		if (pegCurrPos > top.pos) {
			top.pos = pegCurrPos;
			top.variants = [];
		}

		top.variants.push(expected);
	}

	function pegEnd(invert) {
		var expected = pegExpected.pop();
		var top = pegExpected[pegExpected.length - 1];
		var variants = expected.variants;

		if (top.pos !== expected.pos) {
			return;
		}

		if (invert) {
			variants = variants.map((e) => (e.type === "not" ? e.expected : { type: "not", expected: e }));
		}

		Array.prototype.push.apply(top.variants, variants);
	}

	function pegBuildSimpleError(message, location) {
		return new pegSyntaxError(message, null, null, location);
	}

	function pegBuildStructuredError(expected, found, location) {
		return new pegSyntaxError(pegSyntaxError.buildMessage(expected, found, location), expected, found, location);
	}

	function pegBuildError() {
		var expected = pegExpected[0];
		var failPos = expected.pos;

		return pegBuildStructuredError(
			expected.variants,
			failPos < input.length ? input.charAt(failPos) : null,
			failPos < input.length ? pegComputeLocation(failPos, failPos + 1) : pegComputeLocation(failPos, failPos),
		);
	}

	function pegParseTop() {
		var s0;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegParseTopLevelValue();
		if (s0 === pegFailed) {
			s0 = pegParseAnnotation();
			if (s0 === pegFailed) {
				s0 = pegParseTagOpen();
				if (s0 === pegFailed) {
					s0 = pegParseTagClose();
				}
			}
		}

		return s0;
	}

	function pegParseTopLevelValue() {
		var s0, s1;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseVariable();
		if (s1 === pegFailed) {
			s1 = pegParseFunction();
		}
		if (s1 !== pegFailed) {
			pegSavedPos = s0;
			s1 = pegF0(s1);
		}
		s0 = s1;

		return s0;
	}

	function pegParseAnnotation() {
		var s0, s1, s2, s3;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseTagAttributes();
		if (s1 !== pegFailed) {
			s2 = [];
			s3 = pegParse();
			while (s3 !== pegFailed) {
				s2.push(s3);
				s3 = pegParse();
			}
			pegSavedPos = s0;
			s0 = pegF1(s1);
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseTagOpen() {
		var s0, s1, s2, s3, s4, s5, s6;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseTagName();
		if (s1 !== pegFailed) {
			s2 = [];
			s3 = pegParse();
			while (s3 !== pegFailed) {
				s2.push(s3);
				s3 = pegParse();
			}
			s3 = pegCurrPos;
			s4 = pegParseValue();
			if (s4 !== pegFailed) {
				s5 = pegParse();
				if (s5 === pegFailed) {
					s5 = null;
				}
				pegSavedPos = s3;
				s3 = pegF2(s1, s4);
			} else {
				pegCurrPos = s3;
				s3 = pegFailed;
			}
			if (s3 === pegFailed) {
				s3 = null;
			}
			s4 = pegParseTagAttributes();
			if (s4 === pegFailed) {
				s4 = null;
			}
			s5 = [];
			s6 = pegParse();
			while (s6 !== pegFailed) {
				s5.push(s6);
				s6 = pegParse();
			}
			ruleExpects(pegE0);
			if (input.charCodeAt(pegCurrPos) === 47) {
				s6 = pegC0;
				pegCurrPos++;
			} else {
				s6 = pegFailed;
			}
			if (s6 === pegFailed) {
				s6 = null;
			}
			pegSavedPos = s0;
			s0 = pegF3(s1, s3, s4, s6);
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseTagClose() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		ruleExpects(pegE0);
		if (input.charCodeAt(pegCurrPos) === 47) {
			s1 = pegC0;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = pegParseTagName();
			if (s2 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF4(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseTagName() {
		var s0;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE1);
		pegSilentFails++;
		s0 = pegParseIdentifier();
		pegSilentFails--;

		return s0;
	}

	function pegParseTagAttributes() {
		var s0, s1, s2, s3;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseTagAttributesItem();
		if (s1 !== pegFailed) {
			s2 = [];
			s3 = pegParseTagAttributesTail();
			while (s3 !== pegFailed) {
				s2.push(s3);
				s3 = pegParseTagAttributesTail();
			}
			pegSavedPos = s0;
			s0 = pegF5(s1, s2);
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseTagAttributesTail() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = [];
		s2 = pegParse();
		if (s2 !== pegFailed) {
			while (s2 !== pegFailed) {
				s1.push(s2);
				s2 = pegParse();
			}
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = pegParseTagAttributesItem();
			if (s2 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF6(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseTagAttributesItem() {
		var s0, s1;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseTagShortcutId();
		if (s1 !== pegFailed) {
			pegSavedPos = s0;
			s1 = pegF7(s1);
		}
		s0 = s1;
		if (s0 === pegFailed) {
			s0 = pegCurrPos;
			s1 = pegParseTagShortcutClass();
			if (s1 !== pegFailed) {
				pegSavedPos = s0;
				s1 = pegF8(s1);
			}
			s0 = s1;
			if (s0 === pegFailed) {
				s0 = pegCurrPos;
				s1 = pegParseTagAttribute();
				if (s1 !== pegFailed) {
					pegSavedPos = s0;
					s1 = pegF9(s1);
				}
				s0 = s1;
			}
		}

		return s0;
	}

	function pegParseTagShortcutClass() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE2);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (input.charCodeAt(pegCurrPos) === 46) {
			s1 = pegC1;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = pegParseIdentifier();
			if (s2 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF10(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParseTagShortcutId() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE3);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (input.charCodeAt(pegCurrPos) === 35) {
			s1 = pegC2;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = pegParseIdentifier();
			if (s2 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF11(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParseTagAttribute() {
		var s0, s1, s2, s3;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseIdentifier();
		if (s1 !== pegFailed) {
			ruleExpects(pegE4);
			if (input.charCodeAt(pegCurrPos) === 61) {
				s2 = pegC3;
				pegCurrPos++;
			} else {
				s2 = pegFailed;
			}
			if (s2 !== pegFailed) {
				s3 = pegParseValue();
				if (s3 !== pegFailed) {
					pegSavedPos = s0;
					s0 = pegF12(s1, s3);
				} else {
					pegCurrPos = s0;
					s0 = pegFailed;
				}
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseFunction() {
		var s0, s1, s2, s3, s4, s5, s6, s7;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseIdentifier();
		if (s1 !== pegFailed) {
			ruleExpects(pegE5);
			if (input.charCodeAt(pegCurrPos) === 40) {
				s2 = pegC4;
				pegCurrPos++;
			} else {
				s2 = pegFailed;
			}
			if (s2 !== pegFailed) {
				s3 = [];
				s4 = pegParse();
				while (s4 !== pegFailed) {
					s3.push(s4);
					s4 = pegParse();
				}
				s4 = pegCurrPos;
				s5 = pegParseFunctionParameter();
				if (s5 === pegFailed) {
					s5 = null;
				}
				s6 = [];
				s7 = pegParseFunctionParameterTail();
				while (s7 !== pegFailed) {
					s6.push(s7);
					s7 = pegParseFunctionParameterTail();
				}
				pegSavedPos = s4;
				s4 = pegF13(s1, s5, s6);
				ruleExpects(pegE6);
				if (input.charCodeAt(pegCurrPos) === 41) {
					s5 = pegC5;
					pegCurrPos++;
				} else {
					s5 = pegFailed;
				}
				if (s5 !== pegFailed) {
					pegSavedPos = s0;
					s0 = pegF14(s1, s4);
				} else {
					pegCurrPos = s0;
					s0 = pegFailed;
				}
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseFunctionParameter() {
		var s0, s1, s2, s3;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegCurrPos;
		s2 = pegParseIdentifier();
		if (s2 !== pegFailed) {
			ruleExpects(pegE4);
			if (input.charCodeAt(pegCurrPos) === 61) {
				s3 = pegC3;
				pegCurrPos++;
			} else {
				s3 = pegFailed;
			}
			if (s3 !== pegFailed) {
				pegSavedPos = s1;
				s1 = pegF15(s2);
			} else {
				pegCurrPos = s1;
				s1 = pegFailed;
			}
		} else {
			pegCurrPos = s1;
			s1 = pegFailed;
		}
		if (s1 === pegFailed) {
			s1 = null;
		}
		s2 = pegParseValue();
		if (s2 !== pegFailed) {
			pegSavedPos = s0;
			s0 = pegF16(s1, s2);
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseFunctionParameterTail() {
		var s0, s1, s2, s3, s4;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = [];
		s2 = pegParse();
		while (s2 !== pegFailed) {
			s1.push(s2);
			s2 = pegParse();
		}
		ruleExpects(pegE7);
		if (input.charCodeAt(pegCurrPos) === 44) {
			s2 = pegC6;
			pegCurrPos++;
		} else {
			s2 = pegFailed;
		}
		if (s2 !== pegFailed) {
			s3 = [];
			s4 = pegParse();
			while (s4 !== pegFailed) {
				s3.push(s4);
				s4 = pegParse();
			}
			s4 = pegParseFunctionParameter();
			if (s4 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF17(s4);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseTrailingComma() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = [];
		s2 = pegParse();
		while (s2 !== pegFailed) {
			s1.push(s2);
			s2 = pegParse();
		}
		ruleExpects(pegE7);
		if (input.charCodeAt(pegCurrPos) === 44) {
			s2 = pegC6;
			pegCurrPos++;
		} else {
			s2 = pegFailed;
		}
		if (s2 !== pegFailed) {
			s1 = [s1, s2];
			s0 = s1;
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		if (s0 === pegFailed) {
			s0 = null;
		}

		return s0;
	}

	function pegParseVariable() {
		var s0, s1, s2, s3, s4;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE8);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (pegR0.test(input.charAt(pegCurrPos))) {
			s1 = input.charAt(pegCurrPos);
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = pegParseIdentifier();
			if (s2 !== pegFailed) {
				s3 = [];
				s4 = pegParseVariableTail();
				while (s4 !== pegFailed) {
					s3.push(s4);
					s4 = pegParseVariableTail();
				}
				pegSavedPos = s0;
				s0 = pegF18(s1, s2, s3);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParseVariableTail() {
		var s0, s1, s2, s3;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		if (input.charCodeAt(pegCurrPos) === 46) {
			s1 = pegC1;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = pegParseIdentifier();
			if (s2 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF15(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		if (s0 === pegFailed) {
			s0 = pegCurrPos;
			if (input.charCodeAt(pegCurrPos) === 91) {
				s1 = pegC7;
				pegCurrPos++;
			} else {
				s1 = pegFailed;
			}
			if (s1 !== pegFailed) {
				s2 = pegParseValueNumber();
				if (s2 === pegFailed) {
					s2 = pegParseValueString();
				}
				if (s2 !== pegFailed) {
					if (input.charCodeAt(pegCurrPos) === 93) {
						s3 = pegC8;
						pegCurrPos++;
					} else {
						s3 = pegFailed;
					}
					if (s3 !== pegFailed) {
						pegSavedPos = s0;
						s0 = pegF17(s2);
					} else {
						pegCurrPos = s0;
						s0 = pegFailed;
					}
				} else {
					pegCurrPos = s0;
					s0 = pegFailed;
				}
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		}

		return s0;
	}

	function pegParseValue() {
		var s0;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegParseValueNull();
		if (s0 === pegFailed) {
			s0 = pegParseValueBoolean();
			if (s0 === pegFailed) {
				s0 = pegParseValueString();
				if (s0 === pegFailed) {
					s0 = pegParseValueNumber();
					if (s0 === pegFailed) {
						s0 = pegParseValueArray();
						if (s0 === pegFailed) {
							s0 = pegParseValueHash();
							if (s0 === pegFailed) {
								s0 = pegParseFunction();
								if (s0 === pegFailed) {
									s0 = pegParseVariable();
								}
							}
						}
					}
				}
			}
		}

		return s0;
	}

	function pegParseValueNull() {
		var s0, s1;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE9);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (input.substr(pegCurrPos, 4) === pegC9) {
			s1 = pegC9;
			pegCurrPos += 4;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			pegSavedPos = s0;
			s1 = pegF19();
		}
		s0 = s1;
		pegSilentFails--;

		return s0;
	}

	function pegParseValueBoolean() {
		var s0, s1;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE10);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (input.substr(pegCurrPos, 4) === pegC10) {
			s1 = pegC10;
			pegCurrPos += 4;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			pegSavedPos = s0;
			s1 = pegF20();
		}
		s0 = s1;
		if (s0 === pegFailed) {
			s0 = pegCurrPos;
			if (input.substr(pegCurrPos, 5) === pegC11) {
				s1 = pegC11;
				pegCurrPos += 5;
			} else {
				s1 = pegFailed;
			}
			if (s1 !== pegFailed) {
				pegSavedPos = s0;
				s1 = pegF21();
			}
			s0 = s1;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParseValueArray() {
		var s0, s1, s2, s3, s4, s5, s6;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		ruleExpects(pegE11);
		if (input.charCodeAt(pegCurrPos) === 91) {
			s1 = pegC7;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = [];
			s3 = pegParse();
			while (s3 !== pegFailed) {
				s2.push(s3);
				s3 = pegParse();
			}
			s3 = pegCurrPos;
			s4 = pegParseValue();
			if (s4 !== pegFailed) {
				s5 = [];
				s6 = pegParseValueArrayTail();
				while (s6 !== pegFailed) {
					s5.push(s6);
					s6 = pegParseValueArrayTail();
				}
				s6 = pegParseTrailingComma();
				pegSavedPos = s3;
				s3 = pegF22(s4, s5);
			} else {
				pegCurrPos = s3;
				s3 = pegFailed;
			}
			if (s3 === pegFailed) {
				s3 = null;
			}
			s4 = [];
			s5 = pegParse();
			while (s5 !== pegFailed) {
				s4.push(s5);
				s5 = pegParse();
			}
			ruleExpects(pegE12);
			if (input.charCodeAt(pegCurrPos) === 93) {
				s5 = pegC8;
				pegCurrPos++;
			} else {
				s5 = pegFailed;
			}
			if (s5 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF23(s3);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseValueArrayTail() {
		var s0, s1, s2, s3, s4;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = [];
		s2 = pegParse();
		while (s2 !== pegFailed) {
			s1.push(s2);
			s2 = pegParse();
		}
		ruleExpects(pegE7);
		if (input.charCodeAt(pegCurrPos) === 44) {
			s2 = pegC6;
			pegCurrPos++;
		} else {
			s2 = pegFailed;
		}
		if (s2 !== pegFailed) {
			s3 = [];
			s4 = pegParse();
			while (s4 !== pegFailed) {
				s3.push(s4);
				s4 = pegParse();
			}
			s4 = pegParseValue();
			if (s4 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF17(s4);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseValueHash() {
		var s0, s1, s2, s3, s4, s5, s6;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		ruleExpects(pegE13);
		if (input.charCodeAt(pegCurrPos) === 123) {
			s1 = pegC12;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = [];
			s3 = pegParse();
			while (s3 !== pegFailed) {
				s2.push(s3);
				s3 = pegParse();
			}
			s3 = pegCurrPos;
			s4 = pegParseValueHashItem();
			if (s4 !== pegFailed) {
				s5 = [];
				s6 = pegParseValueHashTail();
				while (s6 !== pegFailed) {
					s5.push(s6);
					s6 = pegParseValueHashTail();
				}
				s6 = pegParseTrailingComma();
				pegSavedPos = s3;
				s3 = pegF24(s4, s5);
			} else {
				pegCurrPos = s3;
				s3 = pegFailed;
			}
			if (s3 === pegFailed) {
				s3 = null;
			}
			s4 = [];
			s5 = pegParse();
			while (s5 !== pegFailed) {
				s4.push(s5);
				s5 = pegParse();
			}
			ruleExpects(pegE14);
			if (input.charCodeAt(pegCurrPos) === 125) {
				s5 = pegC13;
				pegCurrPos++;
			} else {
				s5 = pegFailed;
			}
			if (s5 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF25(s3);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseValueHashTail() {
		var s0, s1, s2, s3, s4;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = [];
		s2 = pegParse();
		while (s2 !== pegFailed) {
			s1.push(s2);
			s2 = pegParse();
		}
		ruleExpects(pegE7);
		if (input.charCodeAt(pegCurrPos) === 44) {
			s2 = pegC6;
			pegCurrPos++;
		} else {
			s2 = pegFailed;
		}
		if (s2 !== pegFailed) {
			s3 = [];
			s4 = pegParse();
			while (s4 !== pegFailed) {
				s3.push(s4);
				s4 = pegParse();
			}
			s4 = pegParseValueHashItem();
			if (s4 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF6(s4);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseValueHashItem() {
		var s0, s1, s2, s3, s4;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		s1 = pegParseIdentifier();
		if (s1 === pegFailed) {
			s1 = pegParseValueString();
		}
		if (s1 !== pegFailed) {
			ruleExpects(pegE15);
			if (input.charCodeAt(pegCurrPos) === 58) {
				s2 = pegC14;
				pegCurrPos++;
			} else {
				s2 = pegFailed;
			}
			if (s2 !== pegFailed) {
				s3 = [];
				s4 = pegParse();
				while (s4 !== pegFailed) {
					s3.push(s4);
					s4 = pegParse();
				}
				s4 = pegParseValue();
				if (s4 !== pegFailed) {
					pegSavedPos = s0;
					s0 = pegF26(s1, s4);
				} else {
					pegCurrPos = s0;
					s0 = pegFailed;
				}
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseValueNumber() {
		var s0, s1, s2, s3, s4, s5, s6;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE16);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (input.charCodeAt(pegCurrPos) === 45) {
			s1 = pegC15;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 === pegFailed) {
			s1 = null;
		}
		s2 = [];
		if (pegR1.test(input.charAt(pegCurrPos))) {
			s3 = input.charAt(pegCurrPos);
			pegCurrPos++;
		} else {
			s3 = pegFailed;
		}
		if (s3 !== pegFailed) {
			while (s3 !== pegFailed) {
				s2.push(s3);
				if (pegR1.test(input.charAt(pegCurrPos))) {
					s3 = input.charAt(pegCurrPos);
					pegCurrPos++;
				} else {
					s3 = pegFailed;
				}
			}
		} else {
			s2 = pegFailed;
		}
		if (s2 !== pegFailed) {
			s3 = pegCurrPos;
			if (input.charCodeAt(pegCurrPos) === 46) {
				s4 = pegC1;
				pegCurrPos++;
			} else {
				s4 = pegFailed;
			}
			if (s4 !== pegFailed) {
				s5 = [];
				if (pegR1.test(input.charAt(pegCurrPos))) {
					s6 = input.charAt(pegCurrPos);
					pegCurrPos++;
				} else {
					s6 = pegFailed;
				}
				if (s6 !== pegFailed) {
					while (s6 !== pegFailed) {
						s5.push(s6);
						if (pegR1.test(input.charAt(pegCurrPos))) {
							s6 = input.charAt(pegCurrPos);
							pegCurrPos++;
						} else {
							s6 = pegFailed;
						}
					}
				} else {
					s5 = pegFailed;
				}
				if (s5 !== pegFailed) {
					s4 = [s4, s5];
					s3 = s4;
				} else {
					pegCurrPos = s3;
					s3 = pegFailed;
				}
			} else {
				pegCurrPos = s3;
				s3 = pegFailed;
			}
			if (s3 === pegFailed) {
				s3 = null;
			}
			pegSavedPos = s0;
			s0 = pegF27();
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParseValueString() {
		var s0, s1, s2, s3;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE17);
		pegSilentFails++;
		s0 = pegCurrPos;
		if (input.charCodeAt(pegCurrPos) === 34) {
			s1 = pegC16;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s2 = [];
			s3 = pegParseValueStringChars();
			while (s3 !== pegFailed) {
				s2.push(s3);
				s3 = pegParseValueStringChars();
			}
			if (input.charCodeAt(pegCurrPos) === 34) {
				s3 = pegC16;
				pegCurrPos++;
			} else {
				s3 = pegFailed;
			}
			if (s3 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF28(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParseValueStringChars() {
		var s0;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		if (pegR2.test(input.charAt(pegCurrPos))) {
			s0 = input.charAt(pegCurrPos);
			pegCurrPos++;
		} else {
			s0 = pegFailed;
		}
		if (s0 === pegFailed) {
			s0 = pegParseValueStringEscapes();
		}

		return s0;
	}

	function pegParseValueStringEscapes() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		s0 = pegCurrPos;
		if (input.charCodeAt(pegCurrPos) === 92) {
			s1 = pegC17;
			pegCurrPos++;
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			if (input.charCodeAt(pegCurrPos) === 34) {
				s2 = pegC16;
				pegCurrPos++;
			} else {
				s2 = pegFailed;
			}
			if (s2 === pegFailed) {
				if (input.charCodeAt(pegCurrPos) === 92) {
					s2 = pegC17;
					pegCurrPos++;
				} else {
					s2 = pegFailed;
				}
			}
			if (s2 !== pegFailed) {
				pegSavedPos = s0;
				s0 = pegF29(s2);
			} else {
				pegCurrPos = s0;
				s0 = pegFailed;
			}
		} else {
			pegCurrPos = s0;
			s0 = pegFailed;
		}

		return s0;
	}

	function pegParseIdentifier() {
		var s0, s1, s2;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE18);
		pegSilentFails++;
		s0 = pegCurrPos;
		s1 = [];
		if (pegR3.test(input.charAt(pegCurrPos))) {
			s2 = input.charAt(pegCurrPos);
			pegCurrPos++;
		} else {
			s2 = pegFailed;
		}
		if (s2 !== pegFailed) {
			while (s2 !== pegFailed) {
				s1.push(s2);
				if (pegR3.test(input.charAt(pegCurrPos))) {
					s2 = input.charAt(pegCurrPos);
					pegCurrPos++;
				} else {
					s2 = pegFailed;
				}
			}
		} else {
			s1 = pegFailed;
		}
		if (s1 !== pegFailed) {
			s0 = input.substring(s0, pegCurrPos);
		} else {
			s0 = s1;
		}
		pegSilentFails--;

		return s0;
	}

	function pegParse() {
		var s0;

		var ruleExpects = (expected) => {
			if (pegSilentFails === 0) pegExpect(expected);
		};

		ruleExpects(pegE19);
		pegSilentFails++;
		if (pegR4.test(input.charAt(pegCurrPos))) {
			s0 = input.charAt(pegCurrPos);
			pegCurrPos++;
		} else {
			s0 = pegFailed;
		}
		pegSilentFails--;

		return s0;
	}

	const { Variable, Function } = options;

	pegBegin();
	pegResult = pegStartRuleFunction();

	if (pegResult !== pegFailed && pegCurrPos === input.length) {
		return pegResult;
	}
	if (pegResult !== pegFailed && pegCurrPos < input.length) {
		pegExpect(pegEndExpectation());
	}

	throw pegBuildError();
}

export const parse = pegParse;
export const SyntaxError = pegSyntaxError;
